import {RouteComponentProps, useParams} from "react-router";
import PageHeaderLayout from "../../../../layout/pageHeaderLayout";
import styles from "./index.module.css";
import {Button, Card, Col, Form, Input, message, Modal, Popconfirm, Row, Switch} from "antd";
import {useForm, useWatch} from "antd/lib/form/Form";
import * as api from "../../../../apis/platforms/admin/outerOrder";

import React, {useEffect, useState} from "react";
import {useRequest} from "ahooks";
import DatePicker from "../../../../components/DatePicker";
import StandardTable, {StandardColumnsType} from "../../../../components/StandardTable";
import {useHistory} from "react-router-dom";
import {OuterOrderStatusEnum, OuterOrderStatusMapping} from "../../../../utils/constants";
import DealerShippingSelectModal from "../../../../components/DealerShippingSelectModal";
import AreaSelect from "../../../../components/AreaSelect";
import useAntTable from "../../../../utils/useAntTable";
import ContractSelectModal from "../../../../components/ContractSelectModal";
import OrderResultListModal from "../../dealer/cart/components/OrderResultListModal";
import withAuth from "../../../../utils/withAuth";
import Divider from "../../../../components/Divider";
import dayjs from "dayjs";


type RouteParams = {
    id: string
}

const ImproveAddressButton = withAuth('improveAddress', Button);
const PlaceOrderButton = withAuth('placeOrder', Button);
const CloseButton = withAuth('close', Button);

function MeinianNewOrderDetail(props: RouteComponentProps<RouteParams>) {
    const id = useParams<RouteParams>().id;
    const [status, setStatus] = useState()
    const [form] = useForm();
    const [reasonForm] = useForm();
    const history = useHistory();
    const [enableEdit, setEnableEdit] = useState(false);
    const [dealerShippingModalVisible, setDealerShippingModalVisible] = useState(false);
    const [reasonModalVisible, setReasonModalVisible] = useState(false);
    const [contractSelectModalVisible, setContractSelectModalVisible] = useState(false);
    const [orderResultModalVisible, setOrderResultModalVisible] = useState(false);
    const [orderResult, setOrderResult] = useState<Array<any>>([]);
    const [rebate, setRebate] = useState(false);
    /**
     * Force PlaceOrder Option,
     * force: Sample,
     * restrictForce: Restrict,
     */
    const [forcePlaceOrderOption, setForcePlaceOrderOption] = useState<any>({force: false, restrictForce: false});

    const provinceCode = useWatch('provinceCode', form);
    const orderDetails = useWatch('orderDetails', form);
    const externalCustomerCode = useWatch('externalCustomerCode', form);
    const {loading: loadingImproveAddress, run: runImproveAddress} = useRequest(api.improveAddress, {
        manual: true,
        onSuccess(res) {
            message.success('完善地址成功');
            setEnableEdit(false);
            runGetData(id);
        }
    });


    const {loading: loadingGetData, run: runGetData} = useRequest(api.getMeinianNewOrderDetail, {
        manual: true,
        onSuccess(res) {
            form.setFieldsValue(res.data.data);
            setStatus(res.data.data.status);
        }
    });
    const {loading: loadingPlaceOrder, runAsync: runPlaceOrder} = useRequest(api.placeOrder, {
        manual: true,
        onSuccess(res) {
            if (res.data.code == 0) {
                setForcePlaceOrderOption({force: false, restrictForce: false});
                setOrderResult(res.data.data || []);
                setContractSelectModalVisible(false);
                setOrderResultModalVisible(true);
                runGetData(id);
            }
        }
    })
    const {loading: loadingOrderConfirm, run: runOrderConfirm} = useRequest(api.confirmOrderNew, {
        manual: true,
        onSuccess(res) {
            console.log('已确认');
            reasonForm.resetFields();
            runGetData(id)
        }
    })
    const {loading: loadingOrderClose, run: runOrderClose} = useRequest(api.closeOrderNew, {
        manual: true,
        onSuccess(res) {
            console.log('已关闭');
            reasonForm.resetFields();
            runGetData(id)
        }
    })
    const {loading: loadingClose, run: runClose} = useRequest(api.closeOrderDetailNew, {
        manual: true,
        onSuccess(res) {
            console.log('已关闭');
            setReasonModalVisible(false);
            reasonForm.resetFields();
            runGetData(id)
        }
    })

    const {tableProps, form: tableForm} = useAntTable(undefined, {selectTable: true})


    useEffect(() => {
        if (id) {
            runGetData(id);
        }
    }, [id]);

    const handleImproveAddress = () => {
        const value = form.getFieldsValue();
        runImproveAddress({...value, id, source: '新美年'});
    }

    const handleClose = () => {
        reasonForm.validateFields().then(value => {
            const params = {...value};
            params.ids = tableProps.rowSelection.selectedRowKeys;
            params.source = '新美年';
            params.orderNumber = form.getFieldValue('orderNumber');

            if (!params.ids?.length) {
                message.error('请勾选需要关闭的订单');
                setReasonModalVisible(false);
                return;
            }
            runClose(params);
        });
    }

    const handleSelectContract = () => {
        const lines = tableProps.rowSelection.selectedRows;
        if (lines.some((l: any) => l.status != OuterOrderStatusEnum.UnPlacingOrder)) {
            message.error(`请选择"未下单"订单进行操作`);
            return;
        }
        if (lines.some((l: any) => !l.productId)) {
            message.error('未识别的商品无法下单');
            return;
        }
        setContractSelectModalVisible(true);
    }
    const finishContractSelect = (keys: any[], records: any[]) => {
        if (!keys?.length) {
            setContractSelectModalVisible(false);
            return;
        }
        const contract = records[0];
        const lines = tableProps.rowSelection.selectedRowKeys;
        runPlaceOrder({
            ids: lines,
            orderId: id,
            contractId: contract.id,
            orderSource: '新美年',
            rebate,
        }).then(res => {
            if (res.data.code !== 0) {
                let forceKey;
                if (res.data.code == 1) {
                    forceKey = 'force';
                } else if (res.data.code == 2) {
                    forceKey = 'restrictForce';
                } else {
                    return Promise.reject('网络错误');
                }
                const tmpForceOption = {...forcePlaceOrderOption, [forceKey]: true};
                const modal = Modal.confirm({
                    title: '提示',
                    content: res.data.message,
                    okText: '继续下单',
                    cancelText: '取消',
                    onCancel: () => modal.destroy(),
                    onOk: () => {
                        runPlaceOrder({
                            ids: lines,
                            orderId: id,
                            contractId: contract.id,
                            orderSource: '新美年',
                            rebate,
                            ...tmpForceOption
                        });
                        setForcePlaceOrderOption({force: false, restrictForce: false});
                        modal.destroy();
                    }
                })
            } else {
                setForcePlaceOrderOption({force: false, restrictForce: false});
                Promise.resolve(res);
            }
        })
    }

    const finishAddressSelect = (keys: number[], records: any[]) => {
        if (!keys?.length) {
            setDealerShippingModalVisible(false);
            return;
        }
        const address = records[0];
        debugger;
        form.setFieldValue('provinceCode', address.provinceId);
        form.setFieldValue('province', address.province);
        form.setFieldValue('cityCode', address.cityId);
        form.setFieldValue('city', address.city);
        form.setFieldValue('fullAddress', address.address);
        form.setFieldValue('consigneePhone', address.phone);
        form.setFieldValue('consignee', address.name);
        setDealerShippingModalVisible(false);
    }


    const productColumns: StandardColumnsType = [
        {
            dataIndex: 'status',
            key: 'status',
            title: '状态',
            render(v) {
                return OuterOrderStatusMapping[v]
            }
        },
        {
            dataIndex: 'productNumber',
            key: 'productNumber',
            title: '商品编码'
        },
        {
            dataIndex: 'productName',
            key: 'productName',
            title: '商品名称'
        },
        {
            dataIndex: 'specifications',
            key: 'specifications',
            title: '商品规格'
        },
        {
            dataIndex: 'productCategoryId',
            key: 'productCategoryId',
            title: '商品大类'
        },
        {
            dataIndex: 'quantity',
            key: 'quantity',
            title: '数量'
        },
        {
            dataIndex: 'price',
            key: 'price',
            title: '销售价'
        },
        {
            dataIndex: 'availableInventory',
            key: 'availableInventory',
            title: '可用库存'
        },
        {
            dataIndex: 'deliveryDate',
            key: 'deliveryDate',
            title: '计划交期',
            render: (value) => value ? dayjs(value).format('ll') : null
        },
        {
            dataIndex: 'gift',
            key: 'gift',
            title: '赠品',
            render(v) {
                return v ? '是' : '否'
            }
        },
        {
            dataIndex: 'urgent',
            key: 'urgent',
            title: '加急',
            render(v) {
                return v ? '是' : '否'
            }
        },
        {
            dataIndex: 'closeReason',
            key: 'closeReason',
            title: '关闭理由'
        }
    ];

    return <PageHeaderLayout withFooterBar={enableEdit} btnLoading={loadingGetData || loadingImproveAddress}
                             onOk={handleImproveAddress} onCancel={() => setEnableEdit(false)}>
        <Card>
            <h3 className={styles.SectionTitle}>基本信息</h3>
            <div className={styles.Toolbar}>
                <Divider>
                    {status === 3 && (
                        <Popconfirm title={'是否确认订单'} onConfirm={() => runOrderConfirm(id)}>
                            <Button type={"link"} loading={loadingOrderConfirm}>确认</Button>
                        </Popconfirm>
                    )}
                    {(status === 0 || status === 3) && (
                        <Popconfirm title={'是否确认关闭'} onConfirm={() => runOrderClose(id)}>
                            <CloseButton type={"link"} loading={loadingOrderClose}>关闭</CloseButton>
                        </Popconfirm>
                    )}
                    <ImproveAddressButton type={"link"} loading={loadingImproveAddress}
                                          onClick={() => setEnableEdit(true)}>完善地址</ImproveAddressButton>
                    <Button type={"link"} onClick={() => history.goBack()}>返回</Button>
                </Divider>
            </div>
            <Form form={form} labelCol={{span: 6}} disabled>
                <Row>
                    <Col span={8}>
                        <Form.Item name={'orderNumber'} label={'外部单号'}>
                            <Input/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'orderDate'} label={'订单日期'}>
                            <DatePicker style={{width: '100%'}}/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'externalCustomerName'} label={'客户'}>
                            <Input/>
                        </Form.Item>
                        <Form.Item name={'externalCustomerCode'} noStyle/>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'consignee'} label={'收货人'}>
                            <Input/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'consigneePhone'} label={'收货人电话'}>
                            <Input/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'fullAddress'} label={'收货人地址'}>
                            <Input disabled={!enableEdit} addonAfter={enableEdit &&
                                <a onClick={() => setDealerShippingModalVisible(true)}>选取</a>}/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'provinceCode'} label={'省'}>
                            <AreaSelect type={'province'} disabled={!enableEdit}
                                        onChange={(v, o: any) => form.setFieldValue('province', o.children)}/>
                        </Form.Item>
                        <Form.Item name={'province'} noStyle/>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'cityCode'} label={'市'}>
                            <AreaSelect type={"city"} parent={provinceCode} disabled={!enableEdit}
                                        onChange={(v, o: any) => form.setFieldValue('city', o.children)}/>
                        </Form.Item>
                        <Form.Item name={'city'} noStyle/>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'urgent'} label={'加急'} valuePropName={'checked'}>
                            <Switch/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'totalAmount'} label={'订单金额'}>
                            <Input/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name={'qty'} label={'订单数量'}>
                            <Input/>
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item labelCol={{span: 2}} name={'remark'} label={'备注'}>
                            <Input.TextArea rows={3}/>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
            <h3 className={styles.SectionTitle}>商品信息</h3>
            <div className={styles.Toolbar}>
                {status !== 3 && (
                    <Divider>
                        <PlaceOrderButton type={"link"} loading={loadingPlaceOrder}
                                          onClick={handleSelectContract}>下单</PlaceOrderButton>
                        <CloseButton type={"link"} loading={loadingClose}
                                     onClick={() => setReasonModalVisible(true)}>关闭</CloseButton>
                    </Divider>
                )}
            </div>
            <Form form={form} labelCol={{span: 6}} disabled>
                <Form.List name={'orderDetails'}>
                    {
                        fields => null
                    }
                </Form.List>
            </Form>
            <StandardTable {...tableProps} columns={productColumns} dataSource={orderDetails} pagination={false}
                           form={undefined} rowKey={r => r.id}/>
            {form.getFieldValue('customerNo') && <DealerShippingSelectModal
                key={'dealer-shipping'}
                queryParams={{dealerNo: form.getFieldValue('customerNo')}}
                multiple={false}
                open={dealerShippingModalVisible}
                onCancel={() => setDealerShippingModalVisible(false)}
                onComplete={finishAddressSelect}/>}

            <ContractSelectModal
                key={'contract-select'}
                multiple={false}
                url={externalCustomerCode ? `${api.getContracts}?externalCustomerNo=${externalCustomerCode}&system=新美年` : undefined}
                open={contractSelectModalVisible}
                confirmLoading={loadingPlaceOrder}
                onCancel={() => setContractSelectModalVisible(false)}
                rebate={rebate}
                setRebate={setRebate}
                onComplete={finishContractSelect}/>

            <Modal width={400}
                   key={'close'}
                   title={'关闭'}
                   open={reasonModalVisible}
                   onCancel={() => setReasonModalVisible(false)}
                   onOk={handleClose}>
                <Form form={reasonForm}>
                    <Form.Item rules={[{required: true}]} label={'关闭理由'} name={'closeReason'}>
                        <Input.TextArea rows={3}/>
                    </Form.Item>
                </Form>
            </Modal>
            <OrderResultListModal records={orderResult} onCancel={() => setOrderResultModalVisible(false)}
                                  open={orderResultModalVisible}/>
        </Card>
    </PageHeaderLayout>
}

export default MeinianNewOrderDetail;
